import styled, { css } from "styled-components";
import { getMarginStyle, getPaddingStyle, SpacingStyle } from "core/styles/paddingMarginStyle";

const densityConfig = {
  low: [0, 10, 10, 20],
  high: [0, 2, 2, 4],
};

type DashedVariantProps = {
  color?: string;
  dashed?: boolean;
  variant?: "horizontal" | "vertical";
  density?: "high" | "low";
};

const dashedVariant = ({ color, dashed, variant, density = "low" }: DashedVariantProps) =>
  dashed &&
  css`
    background: repeating-linear-gradient(
      to ${variant === "vertical" ? "bottom" : "right"},
      ${color} ${densityConfig[density][0]}px,
      ${color} ${densityConfig[density][1]}px,
      transparent ${densityConfig[density][2]}px,
      transparent ${densityConfig[density][3]}px
    );
  `;

export const Container = styled.div<
  SpacingStyle &
    DashedVariantProps & {
      size?: string | number;
      width?: string;
      height?: string;
    }
>`
  ${({ variant, size, height, width }) =>
    variant === "vertical"
      ? css`
          height: ${height};
          width: ${typeof size === "string" ? size : `${size}px`};
        `
      : css`
          height: ${typeof size === "string" ? size : `${size}px`};
          width: ${width ?? "auto"};
        `}

  background-color: ${({ color }) => color};

  ${getPaddingStyle}
  ${getMarginStyle}
  ${dashedVariant}
`;
